export default "__VITE_ASSET___JDRQSFm__"